import API from '../Config/Api';

/**
 * A customer who taps the button on a business's WhatsApp broadcast lands on the
 * storefront as `/<shop>?b=<token>` — the approved template's button can only
 * open stylon.online, so it cannot point at the API's click counter directly.
 * Nothing on the storefront read `b`, so no broadcast click was counted and the
 * owner's "clicked" number and the keep-in-touch conversion stayed at zero.
 *
 * This reports the landing to `GET /v1/b/<token>` once per token per session.
 * That route counts the click and answers with a redirect back to the shop,
 * which this request neither follows nor needs (`redirect: 'manual'`).
 * Fire-and-forget; never throws.
 */
export function maybeRecordBroadcastClick() {
  if (typeof window === 'undefined') return;
  try {
    const token = new URLSearchParams(window.location.search).get('b');
    if (!token || !/^[\w-]{8,128}$/.test(token)) return;
    const dedupeKey = `stylon_bclick_${token}`;
    if (sessionStorage.getItem(dedupeKey)) return;
    sessionStorage.setItem(dedupeKey, '1');
    const base = String(API?.defaults?.baseURL || '/v1').replace(/\/+$/, '');
    Promise.resolve(
      fetch(`${base}/b/${encodeURIComponent(token)}`, { method: 'GET', mode: 'no-cors', redirect: 'manual', keepalive: true, credentials: 'omit' }),
    ).catch(() => {});
  } catch (_) {
    /* never throw from instrumentation */
  }
}
